// whocare: where signed-out visitors land. Kept free of imports so the app shell and the three-pane
// layout can use it without pulling the news page (loaded on demand) into the main bundle.

export const NEWS_PATH = '/news';

/** Tab -> local news curator account (run by /srv/mastodon/newsdesk on the server). */
export const NEWS_FEEDS = {
  zh: 'news_zh',
  world: 'news_en',
  nz: 'news_nz',
} as const;

export type NewsTab = keyof typeof NEWS_FEEDS;

export const isNewsTab = (value: string | undefined): value is NewsTab =>
  value !== undefined && Object.hasOwn(NEWS_FEEDS, value);

/** Chinese browsers start on the Chinese tab, everyone else on world news. */
export const browserNewsTab = (): NewsTab => {
  const languages =
    navigator.languages.length > 0 ? navigator.languages : [navigator.language];

  return languages[0]?.toLowerCase().startsWith('zh') ? 'zh' : 'world';
};

export const newsLandingPath = () => `${NEWS_PATH}/${browserNewsTab()}`;
